import { allGearboxMetricNames } from '@shared_types/metrics/gearbox_metrics'
import { initializeMetrics } from '@shared_utils/metric_utils'

import { LOAD_GEARBOX, UPDATE_GEARBOX } from '../actions'

const initialState = initializeMetrics(allGearboxMetricNames)

// @TODO fix types
export default function init (previousState = initialState, { type, payload }: { type: string; payload: unknown }) {
  if (type === LOAD_GEARBOX || type === UPDATE_GEARBOX) {
    console.log('init gearbox', payload)
    return Object.assign({}, previousState, payload)
  } else {
    return previousState
  }
}
